import { appConfig } from 'config/app';
import { IGetLaborResponse, ILabor, IRestoreLaborRequest, IUpdateLaborRequest } from 'types';
import { ApiClient } from './ApiClient';

export const LaborReview = {
  getLabor: (siteId: string, date: string) => ApiClient.get<IGetLaborResponse>(`${appConfig.API_BASE_URL}/v1/sites/${siteId}/pos/legion/labor/${date}`),
  updateLabor: (siteId: string, date: string, locationId: string, employeeId: string, body: IUpdateLaborRequest) =>
    ApiClient.put<ILabor>(`${appConfig.API_BASE_URL}/v1/sites/${siteId}/pos/legion/labor/${date}/${encodeURIComponent(locationId)}/${encodeURIComponent(employeeId)}`, body),
  restoreLabor: (siteId: string, date: string, locationId: string, employeeId: string, body: IRestoreLaborRequest) =>
    ApiClient.post<ILabor>(`${appConfig.API_BASE_URL}/v1/sites/${siteId}/pos/legion/labor/${date}/${encodeURIComponent(locationId)}/${encodeURIComponent(employeeId)}/restore`, body),
};
